import Web3 from 'web3';

let web3Provider;
if ( !web3Provider ) {
  // console.log("INITIALIZE WEB3")
  if (window?.ethereum) {
    // console.log('metamask')
    web3Provider = window.ethereum;
    // web3 = new Web3(window.ethereum);
  }
  else if (window.web3) {
    // console.log('injected')
    // use injected web3
    // web3 = window.web3;
    web3Provider = window.web3;
  }
  else {
    // console.log('localhost')
    // web3 = new Web3(new Web3.providers.HttpProvider('http://localhost:8545'));
    web3Provider = new Web3.providers.HttpProvider('http://localhost:8545');
  }
}

const web3 = new Web3(web3Provider)
export default web3;





/*
import Web3 from 'web3';

let web3;
console.log('web3', web3)
if ( !web3 ) {
  console.log("INITIALIZE WEB3")
  const initializeWeb3 = () => {
    if (window?.ethereum) {
      console.log('metamask')
      web3 = new Web3(window.ethereum);
    }
    else if (window.web3) {
      console.log('injected')
      // use injected web3
      web3 = window.web3;
    }
    else {
      console.log('localhost')
      web3 = new Web3(new Web3.providers.HttpProvider('http://localhost:8545'));
    }
  }
} else {
  console.log('ALREADY INITIALIZED WEB3')
}

web3 = new Web3(web3Connector)
export default web3;

*/
